import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const PabrikContext = createContext({ enabled: false, items: [], current: null, canGabungan: false, targetsBriket: [], ready: true });
export const GABUNGAN = "all";
const KEY = "khn_pabrik";

export function PabrikProvider({ user, children }) {
  const isArang = user?.workspace_type === "arang" && user?.role !== "super_admin";
  const [state, setState] = useState({ enabled: false, items: [], current: null, canGabungan: false, targetsBriket: [], ready: !isArang });

  const load = useCallback(async () => {
    if (!isArang) { setState((s) => ({ ...s, enabled: false, ready: true })); return; }
    try {
      const { data } = await api.get("/pabrik/mine");
      if (data.current?.id) localStorage.setItem(KEY, data.current.id); else localStorage.removeItem(KEY);
      setState({ enabled: true, items: data.items, current: data.current, canGabungan: data.can_gabungan, targetsBriket: data.targets_briket || [], ready: true });
    } catch { setState((s) => ({ ...s, ready: true })); }
  }, [isArang]);

  useEffect(() => { load(); }, [load, user?.id]);

  const switchTo = (id) => { localStorage.setItem(KEY, id); setState((s) => ({ ...s, ready: false })); load(); };

  return <PabrikContext.Provider value={{ ...state, switchTo, reload: load }}>{children}</PabrikContext.Provider>;
}

export const usePabrik = () => useContext(PabrikContext);
export const clearPabrik = () => { try { localStorage.removeItem(KEY); } catch { /* ignore */ } };
